//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import M_TBG_BASIC_06 from './M_TBG_BASIC_06';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../Reducer/CommonReducer';
// 최신 뒤로가기 훅 임포트
import { useBackStack } from '../../../Hooks/back/useBackStack';
//#endregion

function M_TBG_BASIC_06F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const activeStep = useSelector((state) => state.common.activeStep);

  // onBack 클로저가 activeStep 최신값을 참조하도록 ref 사용
  const activeStepRef = useRef(activeStep);
  useEffect(() => {
    activeStepRef.current = activeStep;
  }, [activeStep]);

  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });
  const [codeList, setCodeList] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [modalToggle1, setModalToggle1] = useState(false);
  const [gjList, setGjList] = useState([]);
  const [qrcode, setQrcode] = useState();
  const [value, setValue] = useState(0);
  const [state, setState] = useState({
    bottom: false,
    type: '',
  });
  const [duration, setDuration] = useState(600);
  const [current, setCurrent] = useState(0);
  const [total, setTotal] = useState(200);
  const [completed, setCompleted] = useState(0);
  const imgRef = useRef([]);
  //#endregion

  // 뒤로가기 핸들러 수정
  useBackStack({
    type: 'custom',
    onBack: () => {
      // 1. 모달 닫기 우선 처리
      if (modalToggle1 === true) {
        setModalToggle1(false);
        return;
      }

      // 2. 비즈니스 로직 처리 (Step 2로 롤백)
      SaveLogic1(2, 2);
      props.ActiveButton({
        type: 'prev',
        content: true,
        step: 2,
      });

      // 3. 리덕스 상태 변경 (최신 ref 값 기준)
      dispatch(CommonActions.setActiveStep(activeStepRef.current - 1));
    },
  });

  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, [props.startTimeRef]);

  const Init = async () => {
    setLoading(true);
    try {
      await SearchCode();
      await SearchLogic1();
      await SearchLogic3();
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const updateTime = () => {
    if (!props.startTimeRef?.current) return;
    const now = new Date();
    const elapsedSeconds = Math.floor(
      (now.getTime() - props.startTimeRef.current?.getTime()) / 1000
    );
    setCurrent(elapsedSeconds);
  };

  //#region 조회 로직 (생략 - 기존 동일)
  const SearchCode = async () => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [{ procedureName: 'SP_GetCode' }]
      ).then((result) => {
        let data = result.data;
        if (data.length === 0) {
          setCodeList([]);
        } else if (data[0]?.type === 'Error') {
          throw new Error(data[0].message);
        } else {
          setCodeList(data);
        }
      });
    } catch (e) {
      console.error(e);
    }
  };

  const SearchGj = async () => {
    setLoading(true);
    setGjList([]);
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_SITE_GJ_R1',
            _userid: userInfo.userid,
            _authCd: Commons.EncryptAES(userInfo.authCd) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data.length > 0) {
          if (data[0].type === 'Error') {
            throw new Error(data[0].message);
          } else {
            const formattedData = data
              .map((item) => {
                const gjCdList = item.GJ_CD.split(',');
                const gjNmList = item.GJ_NM.split(',');
                return gjCdList.map((gjCd, index) => ({
                  GJ_CD: gjCd,
                  GJ_NM: gjNmList[index],
                }));
              })
              .flat();
            setGjList(formattedData);
          }
        }
      });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const SearchPhoto = async (_list, _item, _index) => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.ftpResponse,
        { value1: Commons.EncryptAES(_item.PHOTO) }
      ).then((result) => {
        let data = result.data;
        if (data !== 'Error') {
          imgRef.current.push({
            ID: _item.ID,
            PROFILE: `data:image/png;base64,${data}`,
          });
          setRowData(
            Commons.InsertNumber(
              _list.map((item) => {
                const matched = imgRef.current.find(
                  (img) => img.ID === item.ID
                );
                return matched ? { ...item, PROFILE: matched.PROFILE } : item;
              })
            )
          );
        }
      });
    } catch (e) {
      console.error(e);
    }
  };

  const SearchLogic1 = async () => {
    setLoading(true);
    setRowData([]);
    imgRef.current = [];
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_M20903_R1',
            _tbmCd: Commons.EncryptAES(props.tbmCdRef.current),
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data[0].type === 'Error') {
          throw new Error(data[0].message);
        } else {
          setRowData(Commons.InsertNumber(data));
          data.forEach((item, index) => {
            item.PHOTO && SearchPhoto(data, item, index);
          });
        }
      });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const SearchLogic2 = async () => {
    setLoading(true);
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_R2',
            _userid: userInfo.userid,
            _authCd: Commons.EncryptAES(userInfo.authCd) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data[0].type === 'Error') {
          throw new Error(data[0].message);
        } else {
          setQrcode(data[0].TBM_CD);
        }
      });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const SearchLogic3 = async () => {
    setLoading(true);
    setCompleted(0);
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_R3',
            _userid: userInfo.userid,
            _authCd: Commons.EncryptAES(userInfo.authCd) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data.length > 0 && data[0].type !== 'Error') {
          setCompleted(data[0].COMPLETE);
        }
      });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 저장 로직
  const SaveLogic1 = async (_eStep, _mStep) => {
    setLoading(true);
    let saveData = [];
    try {
      saveData.push({
        procedureName: 'SP_TBM_STATUS_U1',
        _TBM_CD: Commons.EncryptAES(props.tbmCdRef.current) || '',
        _E_STEP: Commons.EncryptAES(_eStep.toString()) || '',
        _M_STEP: Commons.EncryptAES(_mStep.toString()) || '',
        _USER_ID: userInfo.userid,
      });

      if (saveData.length > 0) {
        await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          saveData
        ).then(async (result) => {
          let data = result?.data[0];
          if (data.type === 'Error') {
            throw new Error(data.message);
          }
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 나머지 함수
  const HandleChange = (event, newValue) => {
    setValue(newValue);
  };

  const ToggleDrawer = (anchor, open, gubun) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setState({ ...state, [anchor]: open, gubun: gubun });
  };
  //#endregion

  return (
    <M_TBG_BASIC_06
      userInfo={userInfo}
      codeList={codeList}
      setCodeList={setCodeList}
      rowData={rowData}
      setRowData={setRowData}
      modalToggle1={modalToggle1}
      setModalToggle1={setModalToggle1}
      gjList={gjList}
      setGjList={setGjList}
      qrcode={qrcode}
      setQrcode={setQrcode}
      value={value}
      setValue={setValue}
      state={state}
      setState={setState}
      duration={duration}
      setDuration={setDuration}
      current={current}
      setCurrent={setCurrent}
      total={total}
      setTotal={setTotal}
      completed={completed}
      setCompleted={setCompleted}
      activeStep={activeStep}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      userCount={props.userCount}
      setUserCount={props.setUserCount}
      check={props.check}
      setCheck={props.setCheck}
      tbmCdRef={props.tbmCdRef}
      SearchLogic2={SearchLogic2}
      SaveLogic1={SaveLogic1}
      SearchGj={SearchGj}
      HandleChange={HandleChange}
      ToggleDrawer={ToggleDrawer}
      ActiveButton={props.ActiveButton}
    />
  );
}

export default M_TBG_BASIC_06F;
